export interface URLObject {
  activityId: number;
  path: string;
  versionId?: string;
  openProperties?: boolean;
  repoId?: string;
  commentId?: number;
}
export const COMMENT_ID_LABEL = "comment_id_";

export function extractIdAndPathFromParameter(param: string): URLObject {
  const url = decodeURIComponent(param).split("?");

  let pair = null,
    data: any = {},
    params;

  if (url.length > 1) {
    let url_data = url[1];
    if (url_data.includes("#comment_id_")) {
      data["commentId"] = url_data.split("#comment_id_")[1];
      url_data = url_data.split("#comment_id_")[0];
    }

    if (url_data.includes("&")) {
      params = url_data.split("&");
      params.forEach(function (d) {
        pair = d.split("=");
        data[pair[0]] = pair[1];
      });
    } else if (url_data.includes("versionId")) {
      params = url_data.split("versionId=");
      data["versionId"] = params[1];
    } else if (url_data.includes("repoId")) {
      params = url_data.split("repoId=");
      data["repoId"] = params[1];
    } else if (url_data.includes("commentId")) {
      params = url_data.split("commentId=");
      data["commentId"] = params[1];
    }
  }

  const decodedParam = url[0].split("/");
  const activityId = Number(decodedParam[0]);
  decodedParam.shift(); //remove the first element

  return {
    activityId,
    path: decodedParam.join("/"),
    ...data
  };
}

// takes a string of form "/home/parent/child" and returns "["/", "Home", "home/child"]"
export function extractTreeViewArrayFromURL(absolutePath: string): string[] {
  const finalArray = ["/"];
  const splitPath = absolutePath.split("/");

  for (const key in splitPath) {
    let collectString = "";
    for (const keyInner in splitPath) {
      if (key >= keyInner) {
        collectString = collectString + splitPath[keyInner] + "/";
      }
    }
    if (collectString !== "/") {
      finalArray.push(collectString);
    }
  }

  return finalArray;
}

export function getPreviewURL(
  activityId: string,
  versionId: string,
  absolutePath: string,
  repoId: string,
  openPropertiesModal: boolean = false
) {
  return (
    "/activity/" +
    activityId +
    encodeURIComponent("/" + absolutePath) +
    encodeURIComponent("?versionId=" + versionId) +
    encodeURIComponent("&repoId=" + repoId) +
    (openPropertiesModal ? encodeURIComponent("&openProperties=true") : "")
  );
}

export const buildSortFilterRequestParams = ({
  repoId,
  location,
  pageNumber,
  pageSize,
  sortModel,
  filterModel
}: any) => {
  const params: any = {
    repoId,
    location,
    pageNumber,
    pageSize
  };
  if (sortModel?.length) {
    params.sort = sortModel;
  }
  if (filterModel?.items?.length) {
    params.filter = {
      items: filterModel.items.map(
        ({ columnField, operatorValue, value }: any) => ({
          columnField,
          operatorValue,
          value
        })
      ),
      linkOperator: filterModel.linkOperator
    };
  }
  return params;
};

// Helper to check if filter is valid
export const isValidFilter = (item: any) => {
  if ("value" in item) {
    if (
      item.operatorValue &&
      ["=", ">=", "<=", "!="].includes(item.operatorValue)
    ) {
      return item.value !== undefined;
    }
    return true;
  }
  return false;
};
